import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-748f9458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "reload-error"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo cursor-pointer fs-3 color-icon" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-error" }, "Error Api", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "data-number" }
const _hoisted_10 = { class: "data-number" }
const _hoisted_11 = { class: "data-number" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "data-number" }
const _hoisted_14 = { class: "data-number" }
const _hoisted_15 = { class: "data-number" }
const _hoisted_16 = { class: "data-number" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "data-number" }
const _hoisted_19 = { class: "data-number" }
const _hoisted_20 = { class: "data-number" }
const _hoisted_21 = { class: "data-number" }
const _hoisted_22 = {
  key: 3,
  class: "text-center fw-bold"
}
const _hoisted_23 = { class: "mt-3 d-flex" }
const _hoisted_24 = { class: "d-flex align-items-center ms-3" }

import { onMounted, ref, watch } from 'vue'
import PaginationModal from '@/components/pagination/paginationContractHistory.vue'
import { translate } from '@/languages/i18n'
import SelectCustom from '@/components/select-custom/index.vue'
import Table from '@/components/table/DashBoardTable.vue'
import communityDashboardService from '@/services/community-dashboard.services'
import { useRoute } from 'vue-router'
import { ConvertYearMonthDay } from '@/constants/datepicker.ts'
import { numberWithCommas } from '@/constants/common.ts'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  content_type: {
    type: Number,
  },
  date: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const loading = ref()
const errorCallApi = ref(false)
const dataListPost = ref([])
const pageOfNumber = ref(30)
const curPage = ref(1)
const sort_type = ref('pv')
const sort_value = ref('desc')
const total_pages = ref(1)

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])
onMounted(() => {
  getDataListPost()
})
watch(
  () => props.date?.from,
  () => {
    curPage.value = 1
    getDataListPost()
  }
)
watch(
  () => props.date?.to,
  () => {
    curPage.value = 1
    getDataListPost()
  }
)
const changeQuery = (query: any): void => {
  pageOfNumber.value = query?.page_of_number
  curPage.value = query?.page
  //2022/11/12 TienNV Fix for UAT Phase2#5120: CB10 (Ph2-R20221116)
  getDataListPost()
}

const changeSort = (query: any): void => {
  curPage.value = 1
  //2022/11/12 TienNV Fix for UAT Phase2#5120: CB10 (Ph2-R20221116)
  sort_type.value = Object.keys(query)[0]
  sort_value.value = Object.values(query)[0]
  getDataListPost()
}

const getDataListPost = async () => {
  loading.value = true
  try {
    const res = await communityDashboardService.getPosts(route?.params?.id, {
      from: props.date?.from ?? '',
      to: props.date?.to ?? '',
      content_type: props.content_type,
      //2022/11/12 TienNV Fix for UAT Phase2#5120: CB10 (Ph2-R20221116)
      page: curPage.value,
      page_of_number: pageOfNumber.value,
      order_key: sort_type.value,
      order_value: sort_value.value,
    })
    if (res.data?.success) {
      errorCallApi.value = false
      total_pages.value = res.data.total_pages
      dataListPost.value = res?.data.data
    } else {
      errorCallApi.value = true
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (!loading.value && errorCallApi.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: getDataListPost,
            class: "reload-error"
          }, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", null, [
      (__props.content_type === 1)
        ? (_openBlock(), _createBlock(Table, {
            key: 0,
            columns: [
        { field: 'created_at', name: _unref(translate)('CB10PostedDate') },
        { field: 'title', name: _unref(translate)('CB10titleTable3') },
        { field: 'user_name', name: _unref(translate)('CB10Contributor') },
        { field: 'pv', name: _unref(translate)('CB10numberPV'), sort: _ctx.sortField === 'pv', classTh: 'class-text-right', activeSort: true },
        { field: 'likes', name: _unref(translate)('CB10NumberLikes'), sort: _ctx.sortField === 'likes', classTh: 'class-text-right' },
        { field: 'comments', name: _unref(translate)('CB10numberComment'), sort: _ctx.sortField === 'comments', classTh: 'class-text-right' },
      ],
            sortCells: ['pv', 'likes', 'comments'],
            onChangeSort: changeSort,
            pageOfNumber: pageOfNumber.value,
            curPage: curPage.value,
            idTable: 'PostTable1'
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataListPost.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass(['align-middle text-center', { rowEven: index % 2 === 0 }])
                }, [
                  _createElementVNode("td", null, _toDisplayString(_unref(ConvertYearMonthDay)(item?.created_at)), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(item?.title), 1),
                  _createElementVNode("td", null, _toDisplayString(item?.user_name), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(numberWithCommas)(item?.pv)), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(numberWithCommas)(item?.likes)), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(numberWithCommas)(item?.comments)), 1)
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["columns", "pageOfNumber", "curPage"]))
        : (__props.content_type === 2)
          ? (_openBlock(), _createBlock(Table, {
              key: 1,
              columns: [
        { field: 'created_at', name: _unref(translate)('CB10PostedDate') },
        { field: 'title', name: _unref(translate)('CB10titleTable3') },
        { field: 'user_name', name: _unref(translate)('CB10Contributor') },
        { field: 'pv', name: _unref(translate)('CB10numberPV'), sort: _ctx.sortField === 'pv', classTh: 'class-text-right', activeSort: true },
        { field: 'interests', name: _unref(translate)('CB10numberIntersts'), sort: _ctx.sortField === 'interests', classTh: 'class-text-right' },
        { field: 'likes', name: _unref(translate)('CB10NumberLikes'), sort: _ctx.sortField === 'likes', classTh: 'class-text-right' },
        { field: 'comments', name: _unref(translate)('CB10numberComment'), sort: _ctx.sortField === 'comments', classTh: 'class-text-right' },
      ],
              sortCells: ['pv', 'likes', 'comments', 'interests'],
              onChangeSort: changeSort,
              pageOfNumber: pageOfNumber.value,
              curPage: curPage.value,
              idTable: 'PostTable2'
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataListPost.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass(['align-middle text-center', { rowEven: index % 2 === 0 }])
                  }, [
                    _createElementVNode("td", null, _toDisplayString(_unref(ConvertYearMonthDay)(item?.created_at)), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item?.title), 1),
                    _createElementVNode("td", null, _toDisplayString(item?.user_name !== ' ' ? item?.user_name : '運営事務局名'), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(numberWithCommas)(item?.pv)), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(numberWithCommas)(item?.interests)), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(numberWithCommas)(item?.likes)), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(numberWithCommas)(item?.comments)), 1)
                  ], 2))
                }), 128))
              ]),
              _: 1
            }, 8, ["columns", "pageOfNumber", "curPage"]))
          : (_openBlock(), _createBlock(Table, {
              key: 2,
              columns: [
        { field: 'created_at', name: _unref(translate)('CB10PostedDate') },
        { field: 'title', name: _unref(translate)('CB10titleTable3') },
        { field: 'user_name', name: _unref(translate)('CB10Contributor') },
        { field: 'pv', name: _unref(translate)('CB10numberPV'), sort: _ctx.sortField === 'pv', classTh: 'class-text-right', activeSort: true },
        { field: 'interests', name: _unref(translate)('CB10numberIntersts'), sort: _ctx.sortField === 'interests', classTh: 'class-text-right' },
        { field: 'likes', name: _unref(translate)('CB10NumberLikes'), sort: _ctx.sortField === 'likes', classTh: 'class-text-right' },
        { field: 'comments', name: _unref(translate)('CB10numberComment'), sort: _ctx.sortField === 'comments', classTh: 'class-text-right' },
      ],
              sortCells: ['pv', 'likes', 'comments', 'interests'],
              onChangeSort: changeSort,
              pageOfNumber: pageOfNumber.value,
              curPage: curPage.value,
              idTable: 'PostTable3'
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataListPost.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass(['align-middle text-center', { rowEven: index % 2 === 0 }])
                  }, [
                    _createElementVNode("td", null, _toDisplayString(_unref(ConvertYearMonthDay)(item?.created_at)), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(item?.title), 1),
                    _createElementVNode("td", null, _toDisplayString(item?.user_name), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(numberWithCommas)(item?.pv)), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(numberWithCommas)(item?.interests)), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(numberWithCommas)(item?.likes)), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(numberWithCommas)(item?.comments)), 1)
                  ], 2))
                }), 128))
              ]),
              _: 1
            }, 8, ["columns", "pageOfNumber", "curPage"])),
      (dataListPost.value?.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(translate)('CB10NoData')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(PaginationModal, {
          totalPage: total_pages.value || 1,
          onChangeQuery: changeQuery,
          isNotFilterUrl: true,
          pageOfNumber: pageOfNumber.value,
          curPage: curPage.value
        }, null, 8, ["totalPage", "pageOfNumber", "curPage"]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number',
            onChangeQuery: changeQuery,
            isNotFilterUrl: true,
            pageOfNumber: pageOfNumber.value
          }, null, 8, ["options", "pageOfNumber"])
        ])
      ])
    ], 512), [
      [_vShow, !loading.value && !errorCallApi.value]
    ])
  ], 64))
}
}

})